import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { IconListIconTemplateContext } from './models/icon-list-icon-template-context.interface';
import { IconListItem } from './models/icon-list-item.interface';

@Component({
  selector: 'app-icon-list',
  templateUrl: './icon-list.component.html',
  styleUrl: './icon-list.component.scss',
  imports: [NgTemplateOutlet],
})
export class IconListComponent {
  readonly iconTemplate = input<TemplateRef<IconListIconTemplateContext>>();
  readonly items = input.required<IconListItem[]>();
}
